import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TypeIndexEnum } from 'src/app/domain/registration/enums/type-index.enum';
import { UserCrudIndex } from './crud-index';
import { UserService } from '../crud.service';
import { ToastService } from 'src/app/shared/services/toast/toast.service';
import { MediaObserver } from '@angular/flex-layout';
import { AuthService } from 'src/app/views/auth/shared/auth.service';
import { FormBuilder } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-user-index-select',
  templateUrl: './crud-index-select.component.html',
  styleUrls: ['./crud-index-select.component.sass'],
})
export class UserIndexSelectComponent extends UserCrudIndex {
  title: string = 'SELECIONE UM USUÁRIO';
  override displayedColumns = ['name', 'document',];
  
  constructor(
    override dialog: MatDialog,
    override service: UserService,
    override toastService: ToastService,
    override mediaObserver: MediaObserver,
    authService: AuthService,
    fb: FormBuilder,
    public dialogRefSelect: MatDialogRef<UserIndexSelectComponent>,
    @Inject(MAT_DIALOG_DATA)
    data: {
      type: TypeIndexEnum;
      select: boolean;
      params: any;
    }
  ) {
    super(dialog, service, toastService, mediaObserver, authService, fb);
    this.dataSelect = data;
    this.params = { ...this.params, ...data.params };
  }

  override ngOnInit(): void {
    this.loadList();
  }

  override loadList() {
    let params = this.params;

    this.service.listAll(params).subscribe({
      next: (dataWithPagination: any) => {
        let data = dataWithPagination[0];
        this.length = dataWithPagination[1];

        if (data && Array.isArray(data)) {
          this.dataSource = new MatTableDataSource<any>(
            data.map((item: any) => {
              // Processar data de criação
              item['createdAt'] = new Date(item.createdAt).toLocaleDateString('pt-BR');
              
              // IMPORTANTE: Criar campo 'name' consolidado para exibir nome do usuário
              // Prioriza: partner.name > partner.companyName > firstName + lastName > username
              let displayName = '';
              
              if (item.partner) {
                // Se for um parceiro
                if (item.partner.name && item.partner.name.trim() !== '') {
                  displayName = item.partner.name;
                } else if (item.partner.companyName && item.partner.companyName.trim() !== '') {
                  displayName = item.partner.companyName;
                }
              }
              
              // Se não encontrou nome do parceiro, usar firstName + lastName
              if (!displayName && item.firstName && item.lastName) {
                displayName = `${item.firstName} ${item.lastName}`.trim();
              }
              
              // Se ainda não encontrou, usar username
              if (!displayName && item.username) {
                displayName = item.username;
              }
              
              // Fallback final
              if (!displayName) {
                displayName = 'Usuário sem nome';
              }
              
              item['name'] = displayName;
              
              console.log('[UserIndexSelectComponent] Processando usuário:', {
                id: item.id,
                firstName: item.firstName,
                lastName: item.lastName,
                username: item.username,
                partnerName: item.partner?.name,
                partnerCompanyName: item.partner?.companyName,
                displayName: displayName
              });
              
              return item;
            })
          );
        } else {
          this.dataSource = new MatTableDataSource<any>([]);
        }
      },
      error: (error) => {
        console.error('Erro ao carregar usuários:', error);
        this.toastService.showError('Erro ao buscar usuários. Tente novamente.');
        this.dataSource = new MatTableDataSource<any>([]);
      }
    });
  }

  onCancel() {
    this.dialogRefSelect.close();
  }

  onSelect(data: any) {
    this.dialogRefSelect.close(data?.row);
  }

  // Métodos necessários para o template
  _openShow(event: any) {
    // Implementação vazia para compatibilidade
  }

  _openNew(event: any) {
    // Implementação vazia para compatibilidade
  }

  _openEdit(event: any) {
    // Implementação vazia para compatibilidade
  }

  openDelete(event: any) {
    // Implementação vazia para compatibilidade
  }

  submitAdvancedFilter(event: any) {
    // Implementação vazia para compatibilidade
  }
} 